export const TEXT = {
    FieldTypeAddingSection: {en: "Field Adding Section", ar: "قسم إضافة الحقل"},
    FieldOrganization: {en: "Fields Organization Section", ar: "قسم تنظيم الحقول"},
    FieldOrganizationAndPreviewSection: {en: "Fields Organization & Preview Section", ar: "قسم تنظيم الحقول والمعاينة"},
    PreviewSection: {en: "Preview Section", ar: "قسم المعاينة"},
    FieldPreviewSection: {en: "Field Preview", ar: "معاينة الحقول"},
    SelectDbGroupSection: {en: "Select DBGroup Template", ar: "اختر قالب مجموعة قاعدة البيانات"},
    NoDbGroupsAvailable: {en: "No DBGroups available. Please create a DBGroup first.", ar: "لا توجد مجموعات قواعد بيانات متاحة. يرجى إنشاء مجموعة أولاً."},
    DbGroupTemplate: {en: "DBGroup Template", ar: "قالب مجموعة قاعدة البيانات"},
    DatabaseName: {en: "Database Name", ar: "اسم قاعدة البيانات"},
    EnterDatabaseName: {en: "Enter a name for your Database instance", ar: "أدخل اسماً لنسخة قاعدة البيانات"},
    DatabaseNameHelper: {en: "This name identifies your database instance", ar: "هذا الاسم يحدد نسخة قاعدة البيانات الخاصة بك"},
    CreateDatabase: {en: "Create Database", ar: "إنشاء قاعدة بيانات"},
}
export default TEXT;